export { default, ensureComponent } from "./Config";
